import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_v_modal_content = _resolveComponent("v-modal-content")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_modal_content, _mergeProps({
      title: _ctx.t('message.cookies.cookiesManager.title'),
      "hide-confirm": ""
    }, _ctx.$attrs, {
      "with-back-icon": "",
      onCancel: _ctx.back
    }), {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            _createElementVNode("section", null, [
              _createVNode(_component_ion_text, { color: "dark" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("p", null, [
                    _createElementVNode("b", null, "PorritaOnline"),
                    _createTextVNode(" (en adelante, el "),
                    _createElementVNode("b", null, "\"TITULAR\""),
                    _createTextVNode(") informa, a través de la presente Política de Cookies, acerca de la utilización de dispositivos de almacenamiento y recuperación de datos en equipos terminales de los Usuarios. ")
                  ], -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("section", null, [
              _cache[3] || (_cache[3] = _createElementVNode("h3", null, "¿Qué son las cookies?", -1)),
              _createVNode(_component_ion_text, { color: "medium" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("p", null, " Las cookies son archivos o ficheros que se descargan en el ordenador/smartphone/tablet del Usuario al acceder a determinadas páginas web y aplicaciones que permiten almacenar preferencias de la navegación del Usuario, haciendo que la interacción entre el Usuario y el Sitio Web sea más rápida y fácil. ", -1),
                  _createElementVNode("p", null, " La información recogida por las cookies es anónima y no contiene ninguna información sensible ya que no recogen datos que puedan identificar personalmente al Usuario. En cualquier caso, el Usuario podrá acceder a la configuración de su navegador para modificar y/o bloquear la instalación de las Cookies enviadas desde el sitio web, sin que ello impida al acceso a los contenidos. ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("section", null, [
              _cache[5] || (_cache[5] = _createElementVNode("h3", null, [
                _createTextVNode(" ¿Para qué utiliza el "),
                _createElementVNode("span", { class: "font-weight-bold font-italic" }, "TITULAR"),
                _createTextVNode(" las cookies? ")
              ], -1)),
              _createVNode(_component_ion_text, { color: "medium" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("p", null, " De conformidad con la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico (en adelante, “LSSI”), el sitio web utiliza cookies u otros dispositivos de almacenamiento y recuperación de información para realizar un seguimiento de las interacciones de los Usuarios con los servicios ofrecidos en el sitio web. ", -1),
                  _createElementVNode("p", null, [
                    _createTextVNode(" Las "),
                    _createElementVNode("i", null, "cookies"),
                    _createTextVNode(" permiten reconocer el navegador de un Usuario, así como el tipo de dispositivo desde el que se accede al sitio web y se utilizan para facilitar la próxima visita del Usuario y hacer que el sitio web le resulte más útil. ")
                  ], -1),
                  _createElementVNode("p", null, [
                    _createTextVNode(" El "),
                    _createElementVNode("span", { class: "font-weight-bold font-italic" }, "TITULAR"),
                    _createTextVNode(" utiliza las cookies para: ")
                  ], -1),
                  _createElementVNode("ol", { class: "li-space-lg hirodev-ol-red" }, [
                    _createElementVNode("li", null, "Optimizar la navegación del Usuario mediante el seguimiento de la sesión."),
                    _createElementVNode("li", null, "Recopilar información para optimizar la navegación y mejorar el sitio web.")
                  ], -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("section", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.t("message.cookies.cookiesManager.cookiesUsed")), 1),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.t("message.cookies.cookiesManager.needed")), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.t("message.cookies.cookiesManager.neededText")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        slot: "end",
                        disabled: true,
                        checked: true
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.t("message.cookies.cookiesManager.analytics")), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.t("message.cookies.cookiesManager.analyticsText")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        slot: "end",
                        modelValue: _ctx.acceptedAnalytics,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.acceptedAnalytics) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16, ["title", "onCancel"]),
    _createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "medium",
                  onClick: _ctx.submit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("message.cookies.cookiesManager.accept")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_ion_button, {
                  color: "primary",
                  onClick: _ctx.submitAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("message.cookies.cookiesManager.acceptAll")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}